// extracted by mini-css-extract-plugin
export default {"wrapper":"s1NxW","content":"JKPo0","header":"QocUK","button":"VhWwp","buttons":"etQTt","copyright":"rMUOw"};